import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavItemIcon = /* @__PURE__ */ __name(({ icon }) => /* @__PURE__ */ React.createElement("div", {
  className: "mds-rebuild-nav-item-icon"
}, icon), "NavItemIcon");
NavItemIcon.displayName = "Nav.Item.Icon";

export { NavItemIcon };
//# sourceMappingURL=icon.js.map
